import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import Modal from '../modals/Modal';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { useSelector,useDispatch } from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";

const MerchantInfo = props => {
    // const { showMerchantInfoModal, closeModal, merchent, handleEdit } = props
    const token = useSelector((state) => state.auth.token);
    const { userType: role } = useSelector((state) => state.auth.user);
    const [merchent, setMerchent] = useState({})
    const [openModal, setOpenModal] = useState(false)
    // eslint-disable-next-line
    const [headerName, setHeaderName] = useState('')
    // eslint-disable-next-line
    const [fileName, setFileName] = useState('')
    // eslint-disable-next-line 
    const [closeModal, setCloseModal] = useState(false)

    const { id: row_id } = useParams(); 
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const objLength = Object.keys(merchent).length > 0;

    const cdn_path =  `${process.env.REACT_APP_PREVIEW_URL}${process.env.REACT_APP_UPLOAD_PATH}`;

    const [documents, setDocuments] = useState([
            { documentTypeId: '', fileName: null , id: null, name:null }
            ]);

     useEffect(() => {
        dispatch(setSwitchRegion(false));
    
        return () => {
            dispatch(setSwitchRegion(true)); // reset when unmounting
        };
        }, [dispatch]);


    useEffect(() => {
        api.merchants.getMerchantsById({ merchentId: row_id },token).then(merchent => {
            if (merchent.success === false) {
                  toast.error(merchent.message);
            }
            setMerchent(merchent.data)
        }).catch(err => {
              toast.error("Something went wrong");
        })
    }, [row_id,token])

    function convertExponentialToDecimal(exponentialNumber) {
        const str = String(exponentialNumber);
        const strVal = str.split(/[eE]/);
        if (strVal.length > 0) {
            return parseFloat(strVal[0]).toFixed(2);
        }
    }

    useEffect(() => {
        // viewProof(headerName, fileName)
    }, [headerName, fileName])



    function viewProof(headerName, fileName) {
        const fileurl = `${cdn_path}${fileName}`; 
        window.open(fileurl, '_blank');
        // const isPdf = fileName.toLowerCase().endsWith('.pdf');
        // if (isPdf) {
        // const pdfUrl = `${cdn_path}${fileName}`; 
        // window.open(pdfUrl, '_blank');

        // }else{
        // setHeaderName(headerName);
        // setFileName(fileName);
        // setOpenModal(true);
        // setCloseModal(false);
        // }
        
    }

    function closeModalPopUp() {
        setOpenModal(false);
        setCloseModal(true);
    }
    const handleGoback = () => {
        navigate(-1);
    }
        useEffect(() => {
                   
        if (row_id) {
            fetchDocumentOptions();
        }
        // eslint-disable-next-line
        }, [row_id]);


        const fetchDocumentOptions = async () => {
            try {
            const responseDoc = await api.merchants.getDocsByMerchantId(
                { merchentId: row_id },
                token
            );

            if (responseDoc.success && Array.isArray(responseDoc.data)) {
                
                const mappedDocuments = responseDoc.data.map(doc => ({
                documentTypeId: doc.documentTypeId,
                fileName: doc.fileName,
                id: doc.id,
                name: doc.documentType.type
                }));

                setDocuments(mappedDocuments); // update your state here
            } else {
                setDocuments([]); // clear if empty or failed
            }
            } catch (error) {
            console.error('Error fetching documents:', error);
            setDocuments([]); // clear on error
            }
        };
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <span className="form-group">
                            <button
                                style={{
                                    width: "auto",
                                    border: "none",
                                    borderRadius: "50%",
                                    position: "relative",
                                }}
                                type="button"
                                className="float-right btn btn-primary mr-4"
                                data-toggle="collapse"
                                onClick={handleGoback}

                            >

                                Back
                            </button>
                        </span>
                        <div className="table-head">
                            <h1 className="sec-header">VIEW MERCHANT</h1>

                        </div>
                        <div className="card">
                            <div className="card-body box-row">

                                {/* <h1 className="section-header float-left">Merchant Details</h1> */}

                               {role === 1 && (
                                    <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                        <Link to={`/edit-merchants/${row_id}`}>
                                            <button className="btn mt-3 submit-btn" variant="primary" type="submit"> Edit </button>
                                        </Link>
                                    </div>
                                )}
                                <div style={{ margin: '0px 50px' }}>
                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Merchant name</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentName}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Address</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentAddress}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Country</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentCountry}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>State</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentState}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>City</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentCity}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Mobile number</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentMobile}</span></div>
                                    </div>

                                    {/* <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Phone number</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentPhone}</span></div>
                                    </div> */}

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Contact person</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentContactPerson}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Email address</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentEmail}</span></div>
                                    </div>

                                    {merchent.merchentGstNo !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>GST number</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentGstNo}</span></div>
                                    </div>}

                                    {/* {merchent.merchentAadharFile !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Aadhar Card Proof</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentAadharFile}</span></div>
                                    </div>}

                                    {merchent.merchentPanFile !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Pan Card Proof</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentPanFile}</span></div>
                                    </div>}

                                    {merchent.merchentAddressFile !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Address Proof</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentAddressFile}</span></div>
                                    </div>}

                                    {merchent.merchentOtherFile !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Other Documents</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentOtherFile}</span></div>
                                    </div>} */}

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>API access</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentApiAccess ? "Yes" : "No"}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Credit Available</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent && convertExponentialToDecimal(merchent.merchentCreditAvalable)}</span></div>
                                    </div>
                                    {merchent.merchentApiKey !== "" && <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>API Key</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{merchent.merchentApiKey}</span></div>
                                    </div>}

                                    {
                                        objLength &&
                                        <div className="form-group row col-md-12">


                                          
                                               {documents.map((doc, index) => (
                                                <div className="col-md-2" key={index}>
                                                    <button
                                                    className="btn submit-btn"
                                                    type="button"
                                                    onClick={() => viewProof(doc.name, doc.fileName)}
                                                    style={{ width: "max-content" }}
                                                    >
                                                    {doc.name}
                                                    </button>
                                                </div>
                                                ))}
                                            

                                      
                                        </div>}

                                    {openModal && <Modal
                                        modalHeader={headerName}
                                        showModal={openModal}
                                        closeModal={closeModalPopUp}
                                    // buttonText="SAVE"
                                    >
                                        <img src={`${cdn_path}${fileName}`} alt="nodwin" height="100%" width="100%" />
                                    </Modal>}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
};

export default MerchantInfo;